import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import lazySizes from 'lazysizes'

Vue.config.productionTip = false

import "./scss/theme.scss";

await store.dispatch("initialize");

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
